import { render, staticRenderFns } from "./PageRenovation.vue?vue&type=template&id=352a2c58&scoped=true"
import script from "./PageRenovation.vue?vue&type=script&lang=js"
export * from "./PageRenovation.vue?vue&type=script&lang=js"
import style0 from "./PageRenovation.vue?vue&type=style&index=0&id=352a2c58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352a2c58",
  null
  
)

export default component.exports